var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from "react";
import { ECourseColumns } from "../../store/store";
import styled from "styled-components";
import { TABLE_CELLS, COURSE_ACCORDION, COURSE_INFO, TABLE_BODY_CELL_SPAN, TABLE_BODY_CELL_LINK, TABLE_BODY_ROW_BOOKED_OUT, TABLE_BODY_ROW_WAITLIST, TABLE_BODY_ROW_FEW_PLACES_LEFT } from "../../classConstants";
import { getClassName, useIntegrationName } from "../../helpers";
import { Accordion, AccordionItem } from "../Form";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { UserList } from "./UserList";
import { AppointmentsList } from "./Appointments";
var courseFactory = function () {
    var CourseAccordion = function (props) {
        var className = props.className;
        var integrationName = useIntegrationName();
        var skippedColumns = [ECourseColumns.COURSE, ECourseColumns.BOOKLINK];
        var columnHeaders = props.columnHeaders.filter(function (_a) {
            var key = _a.key;
            return !skippedColumns.includes(key);
        });
        var showBookingLink = props.columnHeaders.some(function (_a) {
            var key = _a.key;
            return key === ECourseColumns.BOOKLINK;
        });
        var tableClass = getClassName(className || "", COURSE_ACCORDION);
        var t = useTranslation().t;
        var renderBookNowButton = function (data, prop) {
            if (!data[prop])
                return t("course_table.fully_booked");
            var label = data.waitinglist ? t('course_table.add_to_waiting_list') : t('course_table.book_now');
            return React.createElement("a", { "data-integration-name": integrationName, className: TABLE_BODY_CELL_LINK, href: data[prop] }, label);
        };
        var getRow = function (record, _a) {
            var key = _a.key, label = _a.label;
            function getValue() {
                var _a, _b;
                switch (key) {
                    case ECourseColumns.TRAINER:
                        if (!((_a = record[key]) === null || _a === void 0 ? void 0 : _a.length))
                            return null;
                        return React.createElement(UserList, { className: TABLE_BODY_CELL_SPAN, users: (record[key]) });
                    case ECourseColumns.APPOINTMENTS:
                    case ECourseColumns.APPOINTMENT_LIST:
                        if (!((_b = record[key]) === null || _b === void 0 ? void 0 : _b.length))
                            return null;
                        return React.createElement(AppointmentsList, { placement: "course_table", className: TABLE_BODY_CELL_SPAN, data: record[key] });
                }
                return record[key] && parse(record[key]);
            }
            var value = getValue();
            if (!value)
                return null;
            return React.createElement("div", { key: key, className: TABLE_CELLS[key] },
                !label ? null : label + ": ",
                " ",
                value);
        };
        var getItems = function () {
            return props.records.map(function (record) {
                var _a;
                var bookNow = renderBookNowButton(record, ECourseColumns.BOOKLINK);
                var title = record[ECourseColumns.TIMESPAN];
                var courseNameClasses = record["courseNames"].map(function (name) { return "ws-course-" + name; });
                var tagClassNames = record["tagNames"].map(function (name) { return "ws-tags-" + name; });
                var classNames = getClassName.apply(void 0, __spreadArray(__spreadArray([(_a = {},
                        _a[TABLE_BODY_ROW_BOOKED_OUT] = !record[ECourseColumns.BOOKLINK],
                        _a[TABLE_BODY_ROW_WAITLIST] = record.waitinglist,
                        _a[TABLE_BODY_ROW_FEW_PLACES_LEFT] = record.hasFewPlacesLeft,
                        _a)], courseNameClasses), tagClassNames));
                return (React.createElement(AccordionItem, { className: classNames, itemIndex: record.id, key: record.id, scrollOnClick: false, name: record.id, title: title },
                    React.createElement(DataRow, { className: COURSE_INFO }, columnHeaders.map(function (column) { return getRow(record, column); })),
                    showBookingLink && React.createElement(DataRow, { className: COURSE_INFO }, bookNow)));
            });
        };
        return React.createElement(React.Fragment, null,
            React.createElement(Accordion, { connectedAccordion: true, autoUpdate: true, className: tableClass, defaultTab: props.records[0].id }, getItems()));
    };
    return styled(CourseAccordion)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    "], ["\n    "])));
};
export var CourseAccordion = courseFactory();
var DataRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:not(:last-of-type) {\n        margin-bottom: 1rem;\n    }\n"], ["\n    &:not(:last-of-type) {\n        margin-bottom: 1rem;\n    }\n"])));
var templateObject_1, templateObject_2;
